export const SOWType = {
  GET_SOW_DATA: 'GET_SOW_DATA',
  SET_SOW_DATA: 'SET_SOW_DATA',
  SAVE_SOW_DATA: 'SAVE_SOW_DATA',
  UPDATE_SOW_DATA: 'UPDATE_SOW_DATA',
  DELETE_SOW_DATA: 'DELETE_SOW_DATA',
  SET_SOW_LIST_CLIENT_FILTER: 'SET_SOW_LIST_CLIENT_FILTER',
};

/** null = all clients; used with SOW list get-sows and refresh after add/edit */
export const setSowListClientFilterId = (clientId) => ({
  type: SOWType.SET_SOW_LIST_CLIENT_FILTER,
  payload: clientId == null || clientId === "" ? null : Number(clientId),
});

export const getSOWData = (data) => ({
  type: SOWType.GET_SOW_DATA,
  payload: data,
});

export const deleteSOWData = (sowId) => ({
  type: SOWType.DELETE_SOW_DATA,
  payload: { sowId },
});

export const setSOWData = (data) => ({
  type: SOWType.SET_SOW_DATA,
  payload: data,
});

export const saveSOWData = (data) => ({
  type: SOWType.SAVE_SOW_DATA,
  payload: { data },
});

export const updateSOWData = (data) => ({
  type: SOWType.UPDATE_SOW_DATA,
  payload: { data },
});
